import React, {
  useContext,
  useCallback,
  useMemo,
  useEffect,
  useState,
} from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  List,
  IconButton,
  TextField,
  Collapse,
  Grid,
  InputAdornment,
  Pagination,
  Stack,
  Backdrop,
  useTheme,
  Typography,
  MenuItem,
  Divider,
  ListItemButton,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import dayjs from "dayjs";
import DownloadIcon from "@mui/icons-material/Download";
import { useLocation, useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import PaginationAdvance from "../../Components/PaginationAdvance";
import { PAGE_SIZE } from "../../Services/common/const";
import Title from "../../Components/Title";
import ShortcutButton from "../../Components/ShortcutButton";
import { PreferencesContext } from "../../PreferencesContext";
import MissingConsumer from "../../Components/MissingConsumer";
import {
  ExportFilesFunction,
  numberFormat,
  useQuery,
} from "../../shared/CommonFuctions";
import { KeyboardArrowDownSharp } from "@mui/icons-material";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { DateRange } from "react-date-range";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import SplashComponent from "../../Navigation/splash";
import { AlertType } from "../../shared/Modal/AlertType";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import { StyledMenu } from "../../Components/StyleMenus";
import { format } from "date-fns";
import CustomDateRangePicker from "../../Components/CustomDateRange";
import { GetWarehouseList } from "../../Services/WarehouseService";
import MultiSelectSim from "../../Components/MultiSelectSimple";
import { DateRangeIcon } from "@mui/x-date-pickers";
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from "material-ui-popup-state/hooks";
import MultiSelect from "../../Components/MultiSelect";
import DateRangePopup from "../../Components/DateRangePopup";
import {
  GetPurchaseOrderDueDetailReport,
} from "../../Services/ReportService";
import { GetProductList } from "../../Services/CategoryProductService";
import { parametersForSalePage } from "../../StaticData/common";
import { GetPurchaseOrderDueDetailList } from "../../Services/PurchaseService";
import { GetSupplierList } from "../../Services/SupplierService";

const parameters = {
  consumerId: 25,
  branchId: 1,
  pageIndex: 1,
  productIds: "",
  buyerIds: "",
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
  lessThanValue: "",
};

type Order = "asc" | "desc" | "";

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

interface EnhancedTableProps {
  order: Order;
  orderBy: String;
  rowCount: number;
}

export default function PurchaseOrderDueDetailByProduct() {
  const popupState = usePopupState({ variant: "popover", popupId: "demoMenu" });
  const tabMatches = useMediaQuery("(max-width:768px)");
  const theme = useTheme();
  const navigate = useNavigate();
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  const [isLoading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [isCollapsed, setIsCollapsed] = React.useState<any>(true);
  const [openPurchaseOrderDueDetail, setopenPurchaseOrderDueDetail] =
    React.useState<any>([]);
  const [OpenPurchaseOrderDueDetailData, setopenPurchaseOrderDueDetailData] =
    React.useState<any>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [counData, setCounData] = useState(0);
  const [pageStartIndex, setPageStartIndex] = useState(1);
  const [pageEndIndex, setPageEndIndex] = useState(1);
  const [param, setParam] = useState(parameters);
  const [fromDate, setFromDate] = useState<any>(
    userContext.financialYearStartDate
  );
  const [toDate, setToDate] = useState<any>(userContext.financialYearEndDate);
  const [order, setOrder] = useState<Order>("");
  const [warehouseList, setWarehouseList] = React.useState(
    userContext.warehouseColl || []
  );
  const [orderBy, setOrderBy] = useState<keyof Data>("none");
  const [resultData, setResultData] = useState([]);
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const matches = useMediaQuery("(max-width:425px)");
  const edService = new EncryptDecryptService();
  const openExportType = Boolean(anchorEl2);
  const [page, setPage] = React.useState(1);
  const [Curr_page, setCurrPage] = useState(1);
  const [page_Index, setPage_Index] = useState(1);
  const [page_Size, setPage_Size] = useState<any>(10);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGE_SIZE);
  const [categorysSelectedOption, setCategorysSelectedOption] =
    React.useState<any>([]);
  const [selectedWarehouseId, setSelectedWarehouseId] = React.useState<any>([]);
  const [ProductCollection, setProductCollection] = useState<any>([]);
  const [SourceSupplierCollection, setSourceSupplierCollection] = useState<any>([]);
  const [productSelectedOption, setProductSelectedOption] = React.useState<any>(
    []
  );
  const [selectedSaleDueSummary, setSelectedSaleDueSummary] =
    React.useState<any>([]);
  const [selectedSaleDueSummaryData, setSelectedSaleDueSummaryData] =
    React.useState<any>("");
  const [selectedProductIdData, setSelectedProductIdData] = React.useState<any>(
    []
  );
  const [selectedSuppliersId, setSelectedSupplierId] =
    React.useState<any>([]);
  const [selectedSupplierIdData, setSelectedSupplierIdData] =
    React.useState<any>([]);
  const [selectedWarehouseIdData, setSelectedWarehouseIdData] =
    React.useState<any>([]);
  const [selectedInvoiceSeriesType, setSelectedInvoiceSeriesType] =
    React.useState<any>([]);
  const [selectedInvoiceSeriesTypeData, setSelectedInvoiceSeriesTypeData] =
    React.useState<any>([]);
  const [saleStatusSummary, setSaleStatusSummary] = useState<any>(null);

  const [selectedIndex, setSelectedIndex] = React.useState(5);
  const [isCustomDate, setIsCustomDate] = React.useState(false);
  const [dateHeading, setDateHeading] = React.useState<any>(
    "Current financial year"
  );
  const [anchorE4, setAnchorEl4] = React.useState<HTMLButtonElement | null>(
    null
  );

  const [popupAnchor, setPopupAnchor] = useState<HTMLElement | null>(null);
  const [tempFromDate, setTempFromDate] = useState<dayjs.Dayjs | null>(null);
  const [tempToDate, setTempToDate] = useState<dayjs.Dayjs | null>(null);
  const [dateError, setDateError] = useState<string | null>(null);
  const [selectedVoucherTypes, setSelectedVoucherTypes] = useState<string[]>(
    []
  );
  const handleVoucherTypeChange = (selectedValues: string[]) => {
    setSelectedVoucherTypes(selectedValues);
  };

  const [totalAmount, setTotalAmount] = useState({
    orderedQty: 0,
    deliveredQty: 0,
    balanceQuantity: 0,
    balanceValue: 0,
  });

  const location = useLocation();
  let urlParams = useQuery();
  const encryptedProductId = urlParams.get("q");
  let decryptProductId: any = edService.decrypt(encryptedProductId);
  let convertedProductId: any = parseInt(decryptProductId) || 0;

  const pageInfo = useMemo(
    () => ({
      startIndex: (page - 1) * PAGE_SIZE + 1,
      endIndex: (page - 1) * PAGE_SIZE + resultData.length,
      totalPages: Math.ceil(totalCount / PAGE_SIZE),
    }),
    [page, resultData.length, totalCount]
  );

  const handlePageChange = useCallback(
    (event: React.ChangeEvent<unknown>, value: number) => {
      setPage(value);
      setParam((prev) => ({ ...prev, pageIndex: value }));
    },
    []
  );

  const handleChangePageNew = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: number
  ) => {
    if (Curr_page !== value) {
      setCurrPage(value);
      setPage_Index(value);
      fetchPurchaseOrderDueDetailByProductList();
    }
  };
  type PageSizeChangeEvent = {
    value: string;
    label: string;
  };
  const handlePageSizeCahange = (event: PageSizeChangeEvent) => {
    if (event !== null) {
      setPage_Size(event.value);
      setPage_Index(1);
      setCurrPage(1);
    }
  };

  const handleClickPurchaseDue = (index) => {
    if (openPurchaseOrderDueDetail?.includes(index)) {
      setopenPurchaseOrderDueDetail(
        openPurchaseOrderDueDetail?.filter((item) => item !== index)
      );
    } else {
      setopenPurchaseOrderDueDetail([...openPurchaseOrderDueDetail, index]);
    }
  };

  const startDate = new Date(userContext.financialYearStartDate);
  const endDate = new Date(userContext.financialYearEndDate);
  const [selectedDateRange, setDateRange] = useState<any>([
    {
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    },
  ]);

  const handleDateRange = (selected: any, popupState) => {
    // Your logic here
    const calenderHeading =
      format(new Date(selected[0].startDate), "dd-MM-yyyy") +
      " To " +
      format(new Date(selected[0].endDate), "dd-MM-yyyy");
    setDateRange(selected);
    setDateHeading(calenderHeading);
    popupState.close();
  };

  const handleChangeCategory = (object: any) => {
    setProductSelectedOption(object);
    let tempCustomerIdData: any = [];
    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let productId = x.productId;
        x.productId = productId;
        tempCustomerIdData.push(productId.toString());
      }
    });
    setSelectedProductIdData(tempCustomerIdData);
  };

  const handleSupplierChange = (object: any) => {
    setSelectedSupplierId(object);
    let tempSupplierIdData: any = [];
    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let buyerIds = x?.supplierId;
        x.buyerId = buyerIds;
        tempSupplierIdData.push(buyerIds.toString());
      }
    });
    setSelectedSupplierIdData(tempSupplierIdData);
  };

  async function fetchPurchaseOrderDueDetailByProductList() {
    let params = new URLSearchParams();

    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    // params.append("productIds", selectedProductIdData);
    params.append("supplierIds", selectedSupplierIdData);
    if (
      convertedProductId > 0 &&
      selectedProductIdData?.length === 0 &&
      productSelectedOption?.length === 0
    ) {
      params.append("productIds", convertedProductId.toString());
    } else {
      params.append("productIds", selectedProductIdData);
    }
    // params.append("startDate", format(new Date(fromDate), "yyyy-MM-dd"));
    // params.append("endDate", format(new Date(toDate), "yyyy-MM-dd"));
    params.append("pageIndex", page.toString());
    params.append("pageSize", PAGE_SIZE.toString());
    params.append("sortColumn", param.sortColumn);
    params.append("sortDirection", param.sortDirection);
    params.append("searchValue", searchValue ?? "");
    params.append("financialYear", userContext.financialYear.toString());

    try {
      setLoading(true);
      const result: any = await GetPurchaseOrderDueDetailList(params);
      if (result && result.data && result.data.data) {
        let resultData = result.data.data;
        const mainData: [] = result.data.data;
        setResultData(mainData);
        let dataCount = result.data.data.totalCount;
        let showDataCount = Math.ceil(dataCount / PAGE_SIZE);
        setCounData(showDataCount);
        let startIndex = (page - 1) * page + 1;
        // let endIndex = (page_Index - 1) * page_Size;
        let endIndex =
          (page - 1) * PAGE_SIZE +
          (result.data.data?.purchaseOrderDueDetailCollection
            ? result.data.data?.purchaseOrderDueDetailCollection.length
            : 0);

        setTotalAmount({
          orderedQty: resultData?.orderedQuantityTotal || 0,
          deliveredQty: resultData?.deliveredQtyTotal || 0,
          balanceQuantity: resultData?.balanceQuantityTotal || 0,
          balanceValue: resultData?.balanceValueTotal || 0,
        });

        setPageStartIndex(startIndex);
        setPageEndIndex(endIndex);
        setTotalCount(dataCount);
      } else {
        setResultData([]);
        setTotalCount(0);
        setTotalAmount({
          orderedQty: 0,
          deliveredQty: 0,
          balanceQuantity: 0,
          balanceValue: 0,
        });
      }

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof error === "string"
            ? error
            : error?.message || "Error fetching ledger voucher data",
        alertType: AlertType.Error,
      });
    }
  }

  async function GetProductLists() {
    setLoading(true);
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("pageIndex", page.toString());
    params.append("pageSize", "5000");
    params.append("sortColumn", param.sortColumn);
    params.append("sortDirection", param.sortDirection);
    params.append("searchValue", param.searchValue);
    params.append("financialYear", userContext.financialYear.toString());
    // params.append("saleDate",'');

    try {
      let productCollection: any;
      const result: any = await GetProductList(params);
      if (result && result.data.data) {
        productCollection = result.data.data.productCollection;
        setProductCollection(productCollection);
      } else {
      }
      return productCollection;
    } catch (e:any) {
      setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }
  async function getSuppliersList(onInit, searchValue, id) {
    try {
      let params = new URLSearchParams();
      let supCollection: any;
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("pageIndex", parameters.pageIndex.toString());
      params.append("pageSize", parameters.pageSize.toString());
      params.append("sortColumn", parameters.sortColumn);
      params.append("sortDirection", parameters.sortDirection);
      params.append("searchValue", "");
      params.append("financialYear", userContext.financialYear?.toString());
      const result: any = await GetSupplierList(params);
      if (result && result.data && result.data.data) {
        supCollection = result.data.data.supplierCollection;
        setSourceSupplierCollection(supCollection);
      }
      return supCollection;
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }
  async function handelPurchaseOrderDueReportPopup(type: string) {
    setAnchorEl2(null);
    setLoading(true);

    try {
      const params = new URLSearchParams();
      const attachmentName =
        type === "pdf"
          ? "PurchaseOrderDueDetailByProductReport.pdf"
          : "PurchaseOrderDueDetailByProductReport.xls";

      // Backend expects these parameters
      params.append("reportName", "PurchaseOrderDueDetailByProductReport");
      params.append("reportType", type);
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      // params.append("productIds", selectedProductIdData);
      params.append("supplierIds", selectedSupplierIdData);
      if (
        convertedProductId > 0 &&
        selectedProductIdData?.length === 0 &&
        productSelectedOption?.length === 0
      ) {
        params.append("productIds", convertedProductId.toString());
      } else {
        params.append("productIds", selectedProductIdData);
      }
      // params.append("startDate", format(new Date(fromDate), "yyyy-MM-dd"));
      // params.append("endDate", format(new Date(toDate), "yyyy-MM-dd"));
      params.append("pageIndex", page.toString());
      params.append("pageSize", PAGE_SIZE.toString());
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", searchValue ?? "");
      params.append("financialYear", userContext.financialYear.toString());
      params.append("mode", "EXPORT");

      const result: any = await GetPurchaseOrderDueDetailReport(params);

      if (result?.data?.data?.fileData) {
        const fileContent = result.data.data.fileData;
        ExportFilesFunction(attachmentName, type, fileContent);
      } else {
        updateUserContext({
          ...userContext,
          isAlert: true,
          alertMessage: "No data found in report.",
          alertType: AlertType.Warning,
        });
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? e : e?.message || "Error generating report",
        alertType: AlertType.Error,
      });
    } finally {
      setLoading(false);
    }
  }

  const handleCloseExportType = () => {
    setAnchorEl2(null);
  };

  const handleClickExportType = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl2(event.currentTarget);
  };

  function EnhancedTableHead(props: EnhancedTableProps) {
    return (
      // checkBox for Header
      <TableHead>
        <TableRow>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="left">
            {"Product Name"}
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="right">
            {"Ordered Qty"}
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="right">
            {"Used Qty"}
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="right">
            {"Balance Qty"}
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="Right">
            {"Rate ₹"}
          </TableCell>
          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="right">
            {"Ordered Amount ₹"}
          </TableCell>

          <TableCell
            sx={{
              display: {
                xs: "table-cell",
                sm: "table-cell",
                md: "table-cell",
                lg: "table-cell",
              },
              fontWeight: "bold",
              minWidth: "80px",
            }}
            align="right">
            {"Balance Amount ₹"}
          </TableCell>
        </TableRow>
      </TableHead>
    );
  }

  useEffect(() => {
    const productIds = async () => {
      const productData = await GetProductLists();
      if (convertedProductId > 0 && convertedProductId) {
        const filteroption: any = productData?.filter((x) => {
          return x.productId === convertedProductId;
        });

        setProductSelectedOption(filteroption);
        setSelectedProductIdData([convertedProductId.toString()]);
        handleChangeCategory(filteroption);
      }
    };
    productIds();
  }, []);

  useEffect(() => {
    fetchPurchaseOrderDueDetailByProductList();
    GetProductLists();
    getSuppliersList();

  }, [
    fromDate,
    toDate,
    page,
    param.sortColumn,
    selectedProductIdData,
    selectedSupplierIdData,
    param.sortDirection,
    searchValue,
  ]);

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}>
        <SplashComponent />
      </Backdrop>

      <Title pageTitle="Purchase Order Due Detail By Product" />

      {userContext.consumerId > 0 ? (
        <Box
          className="boxContainer"
          sx={{
            "& > :not(style)": {
              width: "100%",
            },
          }}>
          {/* Header Section */}
          <Grid
            className="title-button-responsive"
            item
            xs={6}
            md={3}
            sx={{
              display: "flex !important",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <h4 className="page-title">Purchase Order Due Detail By Product</h4>
            {matches && (
              <Box sx={{ marginLeft: 'auto' }}>
                <Button
                  variant="outlined"
                  onClick={() => navigate(-1)}
                  size="medium"
                >
                  <ShortcutButton label="ESC" />
                  Back
                </Button>
              </Box>
            )}
            {!matches && (
              <>
                <Grid
                  item
                  xs={6}
                  md={3}
                  marginRight={0}
                  textAlign="end"
                  paddingTop="0px"
                >
                  <Box sx={{ display: "flex", gap: 2, alignItems: "end" }}>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Ordered Qty</Typography>
                      <Box className={"inner-tabs tab-all"}>
                        {numberFormat(totalAmount?.orderedQty, 3, 3)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Delivered Qty</Typography>
                      <Box className={"inner-tabs tab-all"}>
                        {numberFormat(totalAmount?.deliveredQty, 3, 3)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Balance Qty</Typography>
                      <Box className={"inner-tabs tab-all"}>
                        {numberFormat(totalAmount?.balanceQuantity, 3, 3)}
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography>Balance Value</Typography>
                      <Box className={"inner-tabs tab-all"}>
                        {numberFormat(totalAmount?.balanceValue, 2, 2)}
                      </Box>
                    </Box>
                    <Box>
                      <Button
                        // color="primary"
                        variant="outlined"
                        onClick={() => navigate(-1)}
                        size="medium"
                      >
                        <ShortcutButton label="ESC" />
                        Back
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </>
            )}
          </Grid>
          {matches && (
            <>
              <Grid item xs={12} md={3}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Ordered Qty</Typography>
                    <Box className={"inner-tabs tab-all"}>
                      {numberFormat(totalAmount?.orderedQty, 3, 3)}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Delivered Qty</Typography>
                    <Box className={"inner-tabs tab-all"}>
                      {numberFormat(totalAmount?.deliveredQty, 3, 3)}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Balance Qty</Typography>
                    <Box className={"inner-tabs tab-all"}>
                      {numberFormat(totalAmount?.balanceQuantity, 3, 3)}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography>Balance Value</Typography>
                    <Box className={"inner-tabs tab-all"}>
                      {numberFormat(totalAmount?.balanceValue, 2, 2)}
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </>
          )}

          {/* Main Paper Section */}
          <Grid className="paper top-space">
            <Paper elevation={4} className="paper-container">
              {/* Search + Filters + Date + Export */}
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                spacing={2}
                className="search-space">
                {/* Search Field + Filters */}
                <Grid item xs={12} md={8}>
                  <Grid container alignItems="center" spacing={2}>
                    {/* MultiSelect Filters */}
                    <Grid item xs={12} sm={3} md={3}>
                      <MultiSelect
                        placeholderLabel="Products"
                        placeholder="Select Product.."
                        options={ProductCollection}
                        onChange={handleChangeCategory}
                        value={productSelectedOption}
                        isSelectAll={true}
                        menuPlacement={"bottom"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={9} md={9}>
                      <MultiSelect
                        placeholderLabel="Suppliers"
                        placeholder="Select Customer.."
                        options={SourceSupplierCollection}
                        onChange={handleSupplierChange}
                        value={selectedSuppliersId}
                        isSelectAll={true}
                        menuPlacement={"bottom"}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Date & Export Buttons */}
                <Grid item xs={12} md={4}>
                  <Grid
                    container
                    alignItems="center"
                    spacing={2}
                    justifyContent="flex-end">
                    {/* Date Range */}
                    <Grid item>
                      <Button
                        className="button-responsive"
                        variant="outlined"
                        // sx={{ marginRight: { sm: "10px" } }}
                        // disabled={
                        //   selectedLedgerAccount === null ||
                        //   selectedLedgerAccount === undefined ||
                        //   selectedLedgerAccount.length === 0 ||
                        //   sourceLedgerColl.length === 0
                        // }
                        onClick={(e) => {
                          e.preventDefault();
                          if (isCollapsed) {
                            setopenPurchaseOrderDueDetail(
                              resultData?.purchaseOrderDueDetailCollection?.map(
                                (item) => item?.purchaseOrderId
                              )
                            );
                            setopenPurchaseOrderDueDetailData(
                              resultData?.purchaseOrderDueDetailDataCollection?.map(
                                (item) => item?.purchaseOrderId
                              )
                            );
                          } else {
                            setopenPurchaseOrderDueDetail([]);
                            setopenPurchaseOrderDueDetailData([]);
                          }
                          setIsCollapsed(!isCollapsed);
                        }}>
                        {isCollapsed ? "expand" : "collapse"}
                      </Button>
                      {/* <Box
                        display="flex"
                        gap={2}
                        justifyContent="end"
                        flexDirection={{
                          xs: "column",
                          sm: "row",
                        }}>

                        <CustomDateRangePicker
                          fromDate={fromDate}
                          setFromDate={setFromDate}
                          toDate={toDate}
                          setToDate={setToDate}
                        />
                      </Box> */}
                    </Grid>

                    {/* Export */}
                    <Grid item>
                      <Button
                        className="button-responsive-stock"
                        variant="outlined"
                        disabled={resultData?.length <= 0}
                        disableElevation
                        onClick={handleClickExportType}
                        startIcon={<DownloadIcon />}
                        endIcon={<KeyboardArrowDownSharp />}>
                        Export
                      </Button>

                      <StyledMenu
                        id="export-menu"
                        MenuListProps={{
                          "aria-labelledby": "export-menu-button",
                        }}
                        anchorEl={anchorEl2}
                        open={openExportType}
                        onClose={handleCloseExportType}>
                        <MenuItem
                          onClick={() => handelPurchaseOrderDueReportPopup("pdf")}>
                          PDF
                        </MenuItem>
                        <MenuItem
                          onClick={() =>
                            handelPurchaseOrderDueReportPopup("Excel")
                          }>
                          Excel
                        </MenuItem>
                      </StyledMenu>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Table Section */}
              <Paper elevation={4} className="paper-container">
                <>
                  {resultData?.purchaseOrderDueDetailCollection?.length > 0 &&
                    resultData.purchaseOrderDueDetailCollection.map(
                      (purchaseDueData, index) => {
                        return (
                          <React.Fragment key={index}>
                            <List component="div" disablePadding>
                              <ListItemButton
                                sx={{
                                  borderTop:
                                    index !== 0 ? "1px solid #e9e9ef" : "none",
                                  "&:hover": {
                                    backgroundColor: "#f1f6fe",
                                  },
                                  backgroundColor:
                                    openPurchaseOrderDueDetail?.includes(
                                      purchaseDueData?.purchaseOrderId
                                    )
                                      ? "#f1f6fe"
                                      : "#fff",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleClickPurchaseDue(purchaseDueData?.purchaseOrderId);
                                }}
                                key={index}>
                                <>
                                  {openPurchaseOrderDueDetail?.includes(
                                    purchaseDueData?.purchaseOrderId
                                  ) ? (
                                    <ExpandLess sx={{ mr: 1 }} />
                                  ) : (
                                    <ExpandMore sx={{ mr: 1 }} />
                                  )}
                                </>
                                {resultData?.purchaseOrderDueDetailCollection
                                  ?.length > 0 &&
                                  resultData?.purchaseOrderDueDetailCollection
                                    .filter(
                                      (x) =>
                                        x.purchaseOrderId === purchaseDueData?.purchaseOrderId
                                    )
                                    .map((data, index) => {
                                      return (
                                        <Grid
                                          sx={{
                                            display: "flex",
                                            gap: 2,
                                            width: "100%",
                                          }}>
                                          <Grid
                                            display={"flex"}
                                            sx={{
                                              width: !tabMatches
                                                ? "33%"
                                                : "100%",
                                            }}>
                                            <Typography
                                              sx={{ fontWeight: 700 }}>
                                              {purchaseDueData?.supplierName}
                                            </Typography>
                                          </Grid>
                                          {!tabMatches && (
                                            <>
                                              <Grid
                                                display={"flex"}
                                                sx={{
                                                  width: "33%",
                                                  gap: 0.5,
                                                }}>
                                                <Typography>
                                                  Order Date:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 700 }}>
                                                  <span>
                                                    {data?.orderDate
                                                      ? new Date(
                                                        data.orderDate
                                                      ).toLocaleDateString(
                                                        "en-GB",
                                                        {
                                                          day: "2-digit",
                                                          month: "2-digit",
                                                          year: "numeric",
                                                        }
                                                      )
                                                      : "-"}
                                                  </span>
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                display={"flex"}
                                                sx={{
                                                  width: "33%",
                                                  gap: 0.5,
                                                }}>
                                                <Typography>
                                                  Ordered Qty:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 700 }}>
                                                  <span>
                                                    {numberFormat(
                                                      data.orderedQty, 3
                                                    )}
                                                  </span>
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                display={"flex"}
                                                sx={{
                                                  width: "33%",
                                                  gap: 0.5,
                                                }}>
                                                <Typography>
                                                  Delivered Qty:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 700 }}>
                                                  <span>
                                                    {numberFormat(
                                                      Math.abs(
                                                        data.deliveredQty
                                                      ), 3
                                                    )}
                                                  </span>
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                display={"flex"}
                                                sx={{
                                                  width: "33%",
                                                  gap: 0.5,
                                                }}>
                                                <Typography>
                                                  Balance Qty:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 700 }}>
                                                  <span>
                                                    {numberFormat(
                                                      Math.abs(data.balanceQty), 3
                                                    )}
                                                  </span>
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                display={"flex"}
                                                sx={{
                                                  width: "33%",
                                                  gap: 0.5,
                                                }}>
                                                <Typography>
                                                  Balance Rate:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 700 }}>
                                                  <span>
                                                    {numberFormat(
                                                      Math.abs(data.balanceRate)
                                                    )}
                                                  </span>
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                display={"flex"}
                                                sx={{
                                                  width: "33%",
                                                  gap: 0.5,
                                                }}>
                                                <Typography>
                                                  Balance Value:
                                                </Typography>
                                                <Typography
                                                  sx={{ fontWeight: 700 }}>
                                                  <span>
                                                    {numberFormat(
                                                      Math.abs(
                                                        data.balanceValue
                                                      )
                                                    )}
                                                  </span>
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                display={"flex"}
                                                sx={{
                                                  width: "33%",
                                                  gap: 0.5,
                                                }}>
                                                {/* <Typography>Due On:</Typography>
                                                <Typography
                                                  sx={{ fontWeight: 700 }}>
                                                  <span>
                                                    {data?.dueOn
                                                      ? new Date(
                                                          data.dueOn
                                                        ).toLocaleDateString(
                                                          "en-GB",
                                                          {
                                                            day: "2-digit",
                                                            month: "2-digit",
                                                            year: "numeric",
                                                          }
                                                        )
                                                      : "-"}
                                                  </span>
                                                </Typography> */}
                                              </Grid>
                                            </>
                                          )}
                                        </Grid>
                                      );
                                    })}
                              </ListItemButton>
                              <Collapse
                                in={openPurchaseOrderDueDetail?.includes(
                                  purchaseDueData?.purchaseOrderId
                                )}
                                timeout="auto"
                                unmountOnExit>
                                {resultData?.purchaseOrderDueDetailDataCollection
                                  ?.length > 0 && (
                                    <TableContainer>
                                      <Table aria-labelledby="tableTitle">
                                        {/* <TableHead className="table-header-color">
                                        <TableRow>
                                          <TableCell
                                            sx={{
                                              display: {
                                                xs: "table-cell",
                                                sm: "table-cell",
                                                md: "table-cell",
                                                lg: "table-cell",
                                              },
                                              fontWeight: "bold",
                                              minWidth: "121px",
                                            }}
                                            align="left">
                                            {"Date"}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              display: {
                                                xs: "table-cell",
                                                sm: "table-cell",
                                                md: "table-cell",
                                                lg: "table-cell",
                                              },
                                              fontWeight: "bold",
                                              minWidth: "121px",
                                            }}
                                            align="left">
                                            {"RefNumber"}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              display: {
                                                xs: "none",
                                                sm: "none",
                                                md: "none",
                                                lg: "table-cell",
                                              },
                                              fontWeight: "bold",
                                            }}
                                            align="left">
                                            {"Type"}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              display: {
                                                xs: "table-cell",
                                                sm: "table-cell",
                                                md: "table-cell",
                                                lg: "table-cell",
                                              },
                                              fontWeight: "bold",
                                            }}
                                            align="left">
                                            {"Qty"}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              display: {
                                                xs: "table-cell",
                                                sm: "table-cell",
                                                md: "table-cell",
                                                lg: "table-cell",
                                              },
                                              fontWeight: "bold",
                                            }}
                                            align="right">
                                            {"Debit"}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              display: {
                                                xs: "table-cell",
                                                sm: "table-cell",
                                                md: "table-cell",
                                                lg: "table-cell",
                                              },
                                              fontWeight: "bold",
                                            }}
                                            align="right">
                                            {"Credit"}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              display: {
                                                xs: "table-cell",
                                                sm: "table-cell",
                                                md: "table-cell",
                                                lg: "table-cell",
                                              },
                                              fontWeight: "bold",
                                              minWidth: "121px",
                                            }}
                                            align="right">
                                            {"Balance"}
                                          </TableCell>
                                        </TableRow>
                                      </TableHead> */}
                                        <TableBody>
                                          {resultData?.purchaseOrderDueDetailDataCollection
                                            ?.filter(
                                              (x) =>
                                                x.purchaseOrderId ===
                                                purchaseDueData?.purchaseOrderId
                                            )
                                            .map((purchaseDueDetailData, index) => {
                                              return (
                                                <TableRow
                                                  sx={{
                                                    "&:hover": {
                                                      backgroundColor: "#f1f6fe",
                                                      cursor: "pointer",
                                                    },
                                                  }}
                                                // onClick={(e) => {
                                                //   e.preventDefault();
                                                //   if (
                                                //     purchaseDueDetailData.isParent
                                                //   ) {
                                                //     handleClickSaleDetail(
                                                //       purchaseDueDetailData?.uniqueId
                                                //     );
                                                //   }
                                                // } }
                                                >
                                                  <TableCell
                                                    sx={{
                                                      display: {
                                                        xs: "table-cell",
                                                        sm: "table-cell",
                                                        md: "table-cell",
                                                        lg: "table-cell",
                                                      },
                                                    }}
                                                    align="left">
                                                    <Button
                                                      disableRipple
                                                      color="inherit"
                                                      // onClick={() =>
                                                      //   voucherRedirect(
                                                      //     purchaseDueDetailData
                                                      //   )
                                                      // }
                                                      // className="manuButton-link"
                                                      style={{
                                                        backgroundColor:
                                                          "transparent",
                                                      }}>
                                                      <span className="text-link">
                                                        {format(
                                                          new Date(
                                                            purchaseDueDetailData?.date
                                                          ),
                                                          "dd-MM-yyyy"
                                                        )}
                                                      </span>
                                                    </Button>
                                                  </TableCell>
                                                  <TableCell
                                                    sx={{
                                                      display: {
                                                        xs: "table-cell",
                                                        sm: "table-cell",
                                                        md: "table-cell",
                                                        lg: "table-cell",
                                                      },
                                                    }}
                                                    align="left">
                                                    {
                                                      purchaseDueDetailData?.productName
                                                    }
                                                  </TableCell>
                                                  <TableCell
                                                    sx={{
                                                      display: {
                                                        xs: "table-cell",
                                                        sm: "table-cell",
                                                        md: "table-cell",
                                                        lg: "table-cell",
                                                      },
                                                    }}
                                                    align="left">
                                                    {purchaseDueDetailData?.type}
                                                  </TableCell>
                                                  <TableCell
                                                    sx={{
                                                      display: {
                                                        xs: "table-cell",
                                                        sm: "table-cell",
                                                        md: "table-cell",
                                                        lg: "table-cell",
                                                      },
                                                    }}
                                                    align="left">
                                                    {purchaseDueDetailData?.refNumber}
                                                  </TableCell>
                                                  <TableCell
                                                    sx={{
                                                      display: {
                                                        xs: "table-cell",
                                                        sm: "table-cell",
                                                        md: "table-cell",
                                                        lg: "table-cell",
                                                        fontWeight: "bold",
                                                      },
                                                    }}
                                                    align="left">
                                                    {purchaseDueDetailData?.qty && purchaseDueDetailData?.unit
                                                      ? `${Number(purchaseDueDetailData.qty).toFixed(3)} ${purchaseDueDetailData.unit}`
                                                      : purchaseDueDetailData?.qty
                                                        ? Number(purchaseDueDetailData.qty).toFixed(3)
                                                        : purchaseDueDetailData?.unit || "-"}
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            })}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  )}
                              </Collapse>
                            </List>
                          </React.Fragment>
                        );
                      }
                    )}
                  {resultData?.purchaseOrderDueDetailCollection?.length > 0 && (
                    <Grid
                      container
                      paddingTop={1}
                      alignItems={"center"}
                      justifyContent={"center"}>
                      <Grid item xs={12} sm={6} className="pagination-label">
                        {pageStartIndex} - {pageEndIndex} of {totalCount}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Stack
                          component="div"
                          alignItems={mobileScreen ? "center" : "end"}
                          justifyContent="center">
                          <Pagination
                            color="primary"
                            count={pageInfo.totalPages}
                            page={page}
                            onChange={handlePageChange}
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  )}
                  {resultData?.purchaseOrderDueDetailCollection?.length <= 0 && (
                    <Typography
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}>
                      No Data is Available.
                    </Typography>
                  )}
                </>
              </Paper>
            </Paper>
          </Grid>
        </Box>
      ) : (
        <Box
          className="boxContainer"
          sx={{
            "& > :not(style)": {
              width: "100%",
            },
          }}>
          <MissingConsumer consumerId={userContext.consumerId} />
        </Box>
      )}
    </>
  );
}
